export const SET_USER_PREFS_STARTED = 'SET_USER_PREFS_STARTED'
export const SET_USER_PREFS_SUCCESS = 'SET_USER_PREFS_SUCCESS'
export const SET_USER_PREFS_FAILURE = 'SET_USER_PREFS_FAILURE'

export const REGISTER_SYSTEM_ACCESS_STARTED = 'REGISTER_SYSTEM_ACCESS_STARTED'
export const REGISTER_SYSTEM_ACCESS_SUCCESS = 'REGISTER_SYSTEM_ACCESS_SUCCESS'
export const REGISTER_SYSTEM_ACCESS_FAILURE = 'REGISTER_SYSTEM_ACCESS_FAILURE'
